import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
interface ShoppingDefaultParams {
  key: string;
  pid: string;
}
@Injectable({
  providedIn: 'root',
})
export class ShoppingService {
  private defaultApiParams: any;
  private baseUrl = environment.shoppingBaseUrl;

  private getAppPage = '/api/getAppPage';
  private getDealDetail = '/api/getdeal';
  private getCoupons = '/api/getCoupons';
  private getCouponDetail = '/api/getcoupon';
  private getProductDetail = '/api/getProductDetail';
  private getBrowseData = '/api/getBrowseData';

  constructor() {}

  getDefaultApiParams() {
    this.defaultApiParams = {
      key: '9odfmef48g1s4',
      pid: 'viv',
    } as ShoppingDefaultParams;
    return this.defaultApiParams;
  }

  getAppPageApi() {
    return this.baseUrl + this.getAppPage;
  }

  getDealDetailApi() {
    return this.baseUrl + this.getDealDetail;
  }

  getCouponDetailApi() {
    return this.baseUrl + this.getCouponDetail;
  }

  getProductDetailApi() {
    return this.baseUrl + this.getProductDetail;
  }

  getCouponListApi() {
    return this.baseUrl + this.getCoupons;
  }

  getBrowseDataApi() {
    return this.baseUrl + this.getBrowseData;
  }
}
